<div class="relative w-full">
  <input
    [type]="type" 
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="isDisabled"
    [readonly]="readonly"
    [attr.maxLength]="maxlength"
    (input)="onInput($event)"
    [ngStyle]="{ 'background-color': inputBackgroundColor }"
    class="w-full pl-12 pr-4 py-3 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-slate-400 
    focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent
    disabled:bg-gray-100 dark:bg-slate-700 disabled:cursor-not-allowed
    transition-all duration-200"
  />
  <div class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
    <img [src]="images.searchIcon" alt="search" class="w-5 h-5 opacity-50 dark:invert" />
  </div>
</div>
